import { KuxEventWithParam } from './events';

export class ErrorEventArgs extends KuxEventWithParam {
  readonly context: string;
  readonly errorCode: string;
  readonly errorMessage: string;

  constructor(
    context: string,
    message: string,
    errorCode: string,
    additionalInfo?: string,
    additionalInfo2?: string,
    additionalInfo3?: string,
  ) {
    super('applicationError');
    this.context = context;
    this.errorCode = errorCode;
    this.errorMessage = message;
    this.param1 = additionalInfo;
    this.param2 = additionalInfo2;
    this.param3 = additionalInfo3;
  }
}
